import Settlement from './Settlement';
import {authRoles} from 'auth/auth';
import LoadUserData from '../../LoadUserData';

export const SettlementConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : authRoles.admin,//['admin','staff']
    routes  : [
        {
            path     : '/settlement',
            component: LoadUserData(Settlement)
        }
    ]
};
